import ApplicationController from './application_controller';

// Connects to data-controller="sticky-header"
export default class extends ApplicationController {
  static targets = ['header'];

  connect() {
    super.connect();
  }

  switch() {
    this.headerTarget.classList.toggle('not-scrolled', window.scrollY < 50);
  }
}
